import React from "react";
import PropTypes from "prop-types";
import {
  Col,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from "reactstrap";
import "flatpickr/dist/themes/material_blue.css";
import { AvForm, AvField } from "availity-reactstrap-validation";
import CustomMiniLoader from "../../../../components/CustomMiniLoader/CustomMiniLoader";

const EditCustomInvoiceModal = props => {
  const {
    isOpen,
    toggle,
    data,
    type,
    bankLoader,
    clientLoader,
    toggleModalUpdate,
  } = props;
  const [editableType, setEditableType] = React.useState("");
  const [hideButtons, setHideButtons] = React.useState(false);

  React.useEffect(() => {
    if (bankLoader || clientLoader) {
      setHideButtons(true);
    } else {
      setHideButtons(false);
      props.isOpen && toggle("", {});
    }
  }, [bankLoader, clientLoader]);

  const handleValidOrderSubmit = (e, errors, params) => {
    if (errors?.length === 0) {
      let values = {
        id: data.id,
        params: {
          ...params,
        },
      };
      toggleModalUpdate(
        {
          type: editableType,
          who: type,
        },
        values
      );
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      autoFocus={true}
      centered={true}
      toggle={() => toggle("", {})}
      size="lg"
    >
      <ModalHeader>
        Edit {type} information
        <button
          type="button"
          onClick={() => toggle("", {})}
          className="close"
          data-dismiss="modal"
          aria-label="Close"
        ></button>
      </ModalHeader>
      <AvForm
        onSubmit={handleValidOrderSubmit}
        className="fade-in-custom-animate"
      >
        <ModalBody>
          {type === "client" ? (
            <Row>
              {/* <Col sm={12} className="mb-2">
                <label htmlFor="">Address:</label>
                <AvField
                  name={"legal_address"}
                  placeholder="Address..."
                  type="text"
                  value={data?.legal_address || ""}
                  className="form-control"
                  validate={{
                    required: {
                      value: true,
                      errorMessage: "Please, enter address",
                    },
                  }}
                />
              </Col> */}
              <Col sm={6} className="mb-2">
                <label htmlFor="">Name:</label>
                <AvField
                  name={"counterparty_name"}
                  placeholder="Name"
                  type="text"
                  value={data?.counterparty_name || ""}
                  className="form-control"
                  validate={{
                    required: {
                      value: true,
                      errorMessage: "Please, enter a name",
                    },
                  }}
                />
              </Col>
              <Col sm={6} className="mb-2">
                <label htmlFor="">Email:</label>
                <AvField
                  name={"customer_email"}
                  placeholder="Email"
                  type="text"
                  value={data?.customer_email || ""}
                  className="form-control"
                  validate={{
                    required: {
                      value: true,
                      errorMessage: "Please, enter a client email",
                    },
                  }}
                />
              </Col>
              <Col sm={6} className="mb-2">
                <label htmlFor="">Country:</label>
                <AvField
                  name={"customer_country"}
                  placeholder="Country"
                  type="text"
                  value={data?.customer_country || ""}
                  className="form-control"
                  validate={{
                    required: {
                      value: true,
                      errorMessage: "Please, enter a country",
                    },
                  }}
                />
              </Col>
              <Col sm={6} className="mb-2">
                <label htmlFor="">City:</label>
                <AvField
                  name={"customer_city"}
                  placeholder="City"
                  type="text"
                  value={data?.customer_city || ""}
                  className="form-control"
                  validate={{
                    required: {
                      value: true,
                      errorMessage: "Please, enter a city",
                    },
                  }}
                />
              </Col>
              <Col sm={6} className="mb-2">
                <label htmlFor="">Street:</label>
                <AvField
                  name={"customer_street"}
                  placeholder="Street"
                  type="text"
                  value={data?.customer_street || ""}
                  className="form-control"
                  validate={{
                    required: {
                      value: true,
                      errorMessage: "Please, enter a street",
                    },
                  }}
                />
              </Col>
              <Col sm={6} className="mb-2">
                <label htmlFor="">Zip:</label>
                <AvField
                  name={"postal_address"}
                  placeholder="Zip"
                  type="text"
                  value={data?.postal_address || ""}
                  className="form-control"
                  validate={{
                    required: {
                      value: true,
                      errorMessage: "Please, enter a zip code",
                    },
                  }}
                />
              </Col>
            </Row>
          ) : (
            <Row>
              {/* <Col sm={6} className="mb-2">
                <label htmlFor="">Bank name:</label>
                <AvField
                  name={"bank_name"}
                  placeholder="Bank name..."
                  type="text"
                  value={data?.bank_name || ""}
                  className="form-control"
                  validate={{
                    required: {
                      value: true,
                      errorMessage: "Please, enter a bank name",
                    },
                  }}
                />
              </Col>
              <Col sm={6} className="mb-2">
                <label htmlFor="">Bank address:</label>
                <AvField
                  name={"bank_address"}
                  placeholder="Bank address..."
                  type="text"
                  value={data?.bank_address || ""}
                  className="form-control"
                  validate={{
                    required: {
                      value: true,
                      errorMessage: "Please, enter a bank address",
                    },
                  }}
                />
              </Col>
              <Col sm={6} className="mb-2">
                <label htmlFor="">Settlement account:</label>
                <AvField
                  name={"settlement_account"}
                  placeholder="Account number..."
                  type="text"
                  value={data?.settlement_account || ""}
                  className="form-control"
                  validate={{
                    required: {
                      value: true,
                      errorMessage: "Please, enter a account number",
                    },
                  }}
                />
              </Col>
              <Col sm={6} className="mb-2">
                <label htmlFor="">Swift code:</label>
                <AvField
                  name={"swift"}
                  placeholder="Swift code..."
                  type="text"
                  value={data?.swift || ""}
                  className="form-control"
                  validate={{
                    required: {
                      value: true,
                      errorMessage: "Please, enter a swift code",
                    },
                  }}
                />
              </Col> */}
              <Col sm={6} className="mb-2">
                <label htmlFor="">Name:</label>
                <AvField
                  name={"counterparty_name"}
                  placeholder="Name"
                  type="text"
                  value={data?.counterparty_name || ""}
                  className="form-control"
                  validate={{
                    required: {
                      value: true,
                      errorMessage: "Please, enter a name",
                    },
                  }}
                />
              </Col>
              <Col sm={6} />
              <Col sm={6} className="mb-2">
                <label htmlFor="">Street:</label>
                <AvField
                  name={"bank_street"}
                  placeholder="Street"
                  type="text"
                  value={data?.bank_street || ""}
                  className="form-control"
                  validate={{
                    required: {
                      value: true,
                      errorMessage: "Please, enter a street",
                    },
                  }}
                />
              </Col>
              <Col sm={6} className="mb-2">
                <label htmlFor="">Country:</label>
                <AvField
                  name={"bank_country"}
                  placeholder="Country"
                  type="text"
                  value={data?.bank_country || ""}
                  className="form-control"
                  validate={{
                    required: {
                      value: true,
                      errorMessage: "Please, enter a country",
                    },
                  }}
                />
              </Col>
              <Col sm={6} className="mb-2">
                <label htmlFor="">Zip:</label>
                <AvField
                  name={"postal_address"}
                  placeholder="Zip"
                  type="text"
                  value={data?.postal_address || ""}
                  className="form-control"
                  validate={{
                    required: {
                      value: true,
                      errorMessage: "Please, enter a zip code",
                    },
                  }}
                />
              </Col>
              <Col sm={6} className="mb-2">
                <label htmlFor="">IBAN:</label>
                <AvField
                  name={"bank_iban"}
                  placeholder="IBAN"
                  type="text"
                  value={data?.bank_iban || ""}
                  className="form-control"
                  validate={{
                    required: {
                      value: true,
                      errorMessage: "Please, enter a iban",
                    },
                  }}
                />
              </Col>
              <Col sm={6} className="mb-2">
                <label htmlFor="">City:</label>
                <AvField
                  name={"bank_city"}
                  placeholder="City"
                  type="text"
                  value={data?.bank_city || ""}
                  className="form-control"
                  validate={{
                    required: {
                      value: true,
                      errorMessage: "Please, enter a city",
                    },
                  }}
                />
              </Col>
              <Col sm={6} className="mb-2">
                <label htmlFor="">SWIFT:</label>
                <AvField
                  name={"swift"}
                  placeholder="SWIFT"
                  type="text"
                  value={data?.swift || ""}
                  className="form-control"
                  validate={{
                    required: {
                      value: true,
                      errorMessage: "Please, enter a swift code",
                    },
                  }}
                />
              </Col>
            </Row>
          )}
        </ModalBody>
        <ModalFooter className="pe-0">
          <Row className="mt-2">
            <Col>
              <div className="text-end">
                {type === "client" ? (
                  <CustomMiniLoader
                    style={{
                      padding: "10px",
                      minWidth: "143px",
                      display: clientLoader ? "" : "none",
                    }}
                    status
                    text="Please wait"
                  />
                ) : (
                  <CustomMiniLoader
                    style={{
                      padding: "10px",
                      minWidth: "143px",
                      display: bankLoader ? "" : "none",
                    }}
                    status
                    text="Please wait"
                  />
                )}
                <button
                  className={`btn btn-success save-user me-2 d-none ${
                    hideButtons && "d-none"
                  }`}
                  onClick={() => setEditableType("create")}
                >
                  Create new
                </button>
                <button
                  type="submit"
                  className={`btn btn-primary save-user ${
                    hideButtons && "d-none"
                  }`}
                  onClick={() => setEditableType("update")}
                >
                  Update changes
                </button>
              </div>
            </Col>
          </Row>
        </ModalFooter>
      </AvForm>
    </Modal>
  );
};

EditCustomInvoiceModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  data: PropTypes.object.isRequired,
  type: PropTypes.string.isRequired,
  bankLoader: PropTypes.bool.isRequired,
  clientLoader: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  toggleModalUpdate: PropTypes.func.isRequired,
};

export default EditCustomInvoiceModal;
